import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {

    // const bypassUrls = ['download-apk']; // match your routing path here

    
    // if (bypassUrls.includes(route.routeConfig?.path || '')) {
    //   return true;
    // } 

    const currentUser = this.auth.currentUserValue;
    console.log('auth',currentUser)

    if (currentUser && this.auth.isAuthenticated) {

      return true;
    }
   
    this.auth.clearSession();
    this.router.navigate(['/auth/login']);
    return false;
  }
  
}
